import { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import React from "react";

const WelcomeName = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [name, setName] = useState("");

  useEffect(() => {
    if (account && account.name) {
      setName(account.name.split(" ")[0]);
      window.sessionStorage.setItem("account", JSON.stringify(account));
    } else {
      setName("");
      window.sessionStorage.removeItem("account");
    }
  }, [account]);

  if (name) {
    return <Typography variant="h6">Welcome, {name}</Typography>;
  } else {
    return null;
  }
};

export default WelcomeName;
